"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));
var _DialogActions = _interopRequireDefault(require("@material-ui/core/DialogActions"));
var _DialogContent = _interopRequireDefault(require("@material-ui/core/DialogContent"));
var _DialogTitle = _interopRequireDefault(require("@material-ui/core/DialogTitle"));
var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));
var _styles = require("@material-ui/core/styles");
var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _Tooltip = _interopRequireDefault(require("../Tooltip"));
var _Typography = _interopRequireDefault(require("../Typography"));
var _colors = require("../../theme/colors");
var _excluded = ["classes"],
  _excluded2 = ["BackdropProps", "dataMetrics", "dialogTitle", "dialogSubtitle", "dialogContent", "dialogActions", "dialogTitleProps", "dialogSubtitleProps", "dialogContentProps", "dialogActionsProps", "disableBackdropClick", "disableCloseIcon", "onClose", "onEscapeKeyDown", "PaperProps"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    backdropRoot: {
      backgroundColor: _colors.opacity.black[60]
    },
    closeButton: {
      color: theme.palette.primary.secondary,
      position: 'absolute',
      right: theme.spacing(2),
      top: theme.spacing(2)
    },
    dialogActionsRoot: {
      height: 52,
      padding: theme.spacing(1, 3)
    },
    dialogContentRoot: {
      margin: theme.spacing(2, 3, 2, 3),
      padding: 0
    },
    headerContainer: {
      padding: theme.spacing(3, 3, 1, 3)
    },
    paperElevation: {
      boxShadow: theme.shadows[19]
    },
    paperRounded: {
      borderRadius: theme.shape.borderRadius / 2
    },
    /* Styles applied to the `Paper` component if `maxWidth="lg"`. */
    paperWidthLg: {
      maxWidth: 884
    },
    /* Styles applied to the `Paper` component if `maxWidth="md"`. */
    paperWidthMd: {
      maxWidth: 640
    },
    /* Styles applied to the `Paper` component if `maxWidth="sm"`. */
    paperWidthSm: {
      maxWidth: 480
    },
    subTitle: {
      color: _colors.opacity.black[60]
    },
    title: {
      color: _colors.opacity.black[87]
    },
    truncatedText: {
      maxWidth: function maxWidth(_ref) {
        var closeIcon = _ref.closeIcon;
        return closeIcon ? "calc(100% - ".concat(theme.spacing(5), "px)") : '100%';
      },
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    }
  };
});
var defaultProps = {
  dataMetrics: {
    actions: 'fuse_dialog_actions',
    content: 'fuse_dialog_content',
    root: 'fuse_dialog',
    title: 'fuse_dialog_title'
  },
  disableBackdropClick: true,
  disableEscapeKeyDown: true,
  fullScreen: false,
  fullWidth: false,
  maxWidth: 'sm',
  scroll: 'paper'
};
var _ref3 = /*#__PURE__*/_react["default"].createElement(_Close["default"], null);
var Dialog = /*#__PURE__*/_react["default"].forwardRef(function (_ref2, ref) {
  var _ref2$classes = _ref2.classes,
    overrideClasses = _ref2$classes === void 0 ? {} : _ref2$classes,
    props = (0, _objectWithoutProperties2["default"])(_ref2, _excluded);
  var _props$BackdropProps = props.BackdropProps,
    BackdropProps = _props$BackdropProps === void 0 ? {} : _props$BackdropProps,
    dataMetrics = props.dataMetrics,
    dialogTitle = props.dialogTitle,
    dialogSubtitle = props.dialogSubtitle,
    dialogContent = props.dialogContent,
    dialogActions = props.dialogActions,
    _props$dialogTitlePro = props.dialogTitleProps,
    dialogTitleProps = _props$dialogTitlePro === void 0 ? {} : _props$dialogTitlePro,
    _props$dialogSubtitle = props.dialogSubtitleProps,
    dialogSubtitleProps = _props$dialogSubtitle === void 0 ? {} : _props$dialogSubtitle,
    _props$dialogContentP = props.dialogContentProps,
    dialogContentProps = _props$dialogContentP === void 0 ? {} : _props$dialogContentP,
    _props$dialogActionsP = props.dialogActionsProps,
    dialogActionsProps = _props$dialogActionsP === void 0 ? {} : _props$dialogActionsP,
    disableBackdropClick = props.disableBackdropClick,
    disableCloseIcon = props.disableCloseIcon,
    onClose = props.onClose,
    onEscapeKeyDown = props.onEscapeKeyDown,
    _props$PaperProps = props.PaperProps,
    PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps,
    other = (0, _objectWithoutProperties2["default"])(props, _excluded2);
  var classes = _objectSpread({}, useStyles({
    closeIcon: Boolean(onClose)
  }), {}, overrideClasses);
  var mergedDataMetrics = _objectSpread({}, defaultProps.dataMetrics, {}, dataMetrics);
  var handleOnClose = (0, _react.useCallback)(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var event = args[0],
      reason = args[1];
    if (disableBackdropClick && reason === "backdropClick") {
      event.preventDefault();
      return;
    }
    if (onEscapeKeyDown && reason === 'escapeKeyDown') {
      onEscapeKeyDown.apply(void 0, args);
    }
    if (onClose) {
      onClose.apply(void 0, args);
    }
  }, [disableBackdropClick, onClose, onEscapeKeyDown]);
  return /*#__PURE__*/_react["default"].createElement(_Dialog["default"], (0, _extends2["default"])({
    BackdropProps: _objectSpread({}, BackdropProps, {
      classes: _objectSpread({
        root: classes.backdropRoot
      }, BackdropProps.classes || {})
    }),
    "data-metrics": mergedDataMetrics.root,
    PaperProps: _objectSpread({}, PaperProps, {
      classes: _objectSpread({
        rounded: classes.paperRounded
      }, PaperProps.classes || {})
    }),
    classes: {
      paper: classes.paperElevation,
      paperWidthLg: classes.paperWidthLg,
      paperWidthMd: classes.paperWidthMd,
      paperWidthSm: classes.paperWidthSm
    },
    onClose: handleOnClose,
    ref: ref
  }, other), /*#__PURE__*/_react["default"].createElement(_DialogTitle["default"], {
    "data-metrics": mergedDataMetrics.title,
    disableTypography: true,
    className: classes.headerContainer
  }, dialogTitle && /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
    title: dialogTitle,
    placement: "bottom-start"
  }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], (0, _extends2["default"])({
    align: "left",
    className: (0, _classnames["default"])(classes.title, classes.truncatedText),
    variant: "h6"
  }, dialogTitleProps), dialogTitle)), dialogSubtitle && /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
    title: dialogSubtitle,
    placement: "bottom-start"
  }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], (0, _extends2["default"])({
    align: "left",
    className: (0, _classnames["default"])(classes.subTitle, classes.truncatedText),
    variant: "subtitle1"
  }, dialogSubtitleProps), dialogSubtitle)), Boolean(onClose) && !disableCloseIcon && /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    "aria-label": "Close",
    className: classes.closeButton,
    color: "secondary",
    onClick: onClose,
    size: "medium"
  }, _ref3)), /*#__PURE__*/_react["default"].createElement(_DialogContent["default"], (0, _extends2["default"])({
    classes: {
      root: classes.dialogContentRoot
    },
    "data-metrics": mergedDataMetrics.content
  }, dialogContentProps), dialogContent), Boolean(dialogActions) && /*#__PURE__*/_react["default"].createElement(_DialogActions["default"], (0, _extends2["default"])({
    classes: {
      root: classes.dialogActionsRoot
    },
    "data-metrics": mergedDataMetrics.actions,
    disableSpacing: true
  }, dialogActionsProps), dialogActions));
});
Dialog.defaultProps = defaultProps;
Dialog.displayName = 'Dialog';
Dialog.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * 	Props applied to the Backdrop element. See [MUI Backdrop Props](https://v4.mui.com/api/backdrop/#props) for more details.
   */
  BackdropProps: _propTypes["default"].object,
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](https://v4.mui.com/api/dialog/#css) for more details.
   */
  classes: _propTypes["default"].object,
  /**
   * @ignore
   */
  className: _propTypes["default"].string,
  /**
   * Override the data-metrics attributes applied to the component.
   */
  dataMetrics: _propTypes["default"].shape({
    actions: _propTypes["default"].string,
    content: _propTypes["default"].string,
    root: _propTypes["default"].string,
    title: _propTypes["default"].string
  }),
  /**
   * Dialog action Bar component. For instance, it can be be a `Button`, a `Switch` or a `Checkbox`.
   */
  dialogActions: _propTypes["default"].element,
  /**
   * Properties for dialog actions. For example, it can be {name:'sample-actions'}. See [MUI DialogActions Props](https://v4.mui.com/api/dialog-actions/#props) for more details.
   */
  dialogActionsProps: _propTypes["default"].object,
  /**
   * Dialog content node.
   */
  dialogContent: _propTypes["default"].node,
  /**
   * Properties for dialog content. See [MUI DialogContent Props](https://v4.mui.com/api/dialog-content/#props) for more details.
   */
  dialogContentProps: _propTypes["default"].object,
  /**
   * Dialog Sub Title.
   */
  dialogSubtitle: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  /**
   * Properties for subtitle
   */
  dialogSubtitleProps: _propTypes["default"].object,
  /**
   * Dialog Title.
   */
  dialogTitle: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]).isRequired,
  /**
   * Properties for title. See [MUI DialogTitle Props](https://v4.mui.com/api/dialog-title/#props) for more details.
   */
  dialogTitleProps: _propTypes["default"].object,
  /**
   * If `true`, clicking the backdrop will not fire the `onClose` callback.
   */
  disableBackdropClick: _propTypes["default"].bool,
  /**
   * If `true`, the close button icon in the header will not be rendered
   */
  disableCloseIcon: _propTypes["default"].bool,
  /**
   * If `true`, cannot press `Esc` to close the dialog
   */
  disableEscapeKeyDown: _propTypes["default"].bool,
  /**
   * If `true`, the dialog will be full-screen
   */
  fullScreen: _propTypes["default"].bool,
  /**
   * If `true`, the dialog stretches to `maxWidth`.
   */
  fullWidth: _propTypes["default"].bool,
  /**
   * Determine the max width of the dialog.
   * The dialog width grows with the size of the screen, this property is useful
   * on the desktop where you might need some coherent different width size across your
   * application. Set to `false` to disable `maxWidth`.
   */
  maxWidth: _propTypes["default"].oneOf(['xs', 'sm', 'md', 'lg', 'xl', false]),
  /**
   * @ignore
   * *Note: deprecated*. Use the `onClose` prop with the `reason` argument to handle the `backdropClick` events.
   * Callback fired when the backdrop is clicked.
   */
  onBackdropClick: _propTypes["default"].func,
  /**
   * Callback fired when the component requests to be closed.
   * Use the onClose prop with the `reason` argument to handle `backdropClick` events.
   *
   * @param {object} event The event source of the callback
   * @param {string} reason Can be: "escapeKeyDown", "backdropClick"
   */
  onClose: _propTypes["default"].func,
  /**
   * @ignore
   * *Note: deprecated*. Use the `TransitionProps` prop instead.
   * Callback fired before the dialog enters.
   */
  onEnter: _propTypes["default"].func,
  /**
   * @ignore
   * *Note: deprecated*. Use the `TransitionProps` prop instead.
   * Callback fired when the dialog has entered.
   */
  onEntered: _propTypes["default"].func,
  /**
   * @ignore
   * *Note: deprecated*. Use the `TransitionProps` prop instead.
   * Callback fired when the dialog is entering.
   */
  onEntering: _propTypes["default"].func,
  /**
   * Callback fired when the escape key is pressed,
   * `disableKeyboard` is false and the modal is in focus.
   */
  onEscapeKeyDown: _propTypes["default"].func,
  /**
   * @ignore
   * *Note: deprecated*. Use the `TransitionProps` prop instead.
   * Callback fired before the dialog exits.
   */
  onExit: _propTypes["default"].func,
  /**
   * @ignore
   * *Note: deprecated*. Use the `TransitionProps` prop instead.
   * Callback fired when the dialog has exited.
   */
  onExited: _propTypes["default"].func,
  /**
   * @ignore
   * *Note: deprecated*. Use the `TransitionProps` prop instead.
   * Callback fired when the dialog is exiting.
   */
  onExiting: _propTypes["default"].func,
  /**
   * If `true`, the Dialog is open.
   */
  open: _propTypes["default"].bool.isRequired,
  /**
   * 	Props applied to the Paper element. See [MUI Paper Props](https://v4.mui.com/api/paper/#props) for more details.
   */
  PaperProps: _propTypes["default"].object,
  /**
   * Determine the container for scrolling the dialog.
   */
  scroll: _propTypes["default"].oneOf(['body', 'paper'])
} : {};
var _default = Dialog;
exports["default"] = _default;